import { render } from "./ValuePlayerSection.vue?vue&type=template&id=8b6c2048"
import script from "./ValuePlayerSection.vue?vue&type=script&lang=js"
export * from "./ValuePlayerSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__